export var ExpiredTokenCode;

(function (ExpiredTokenCode) {
  ExpiredTokenCode[ExpiredTokenCode["Unknown"] = 0] = "Unknown";
  ExpiredTokenCode[ExpiredTokenCode["Inactivity"] = 1] = "Inactivity";
  ExpiredTokenCode[ExpiredTokenCode["Expired"] = 2] = "Expired";
  ExpiredTokenCode[ExpiredTokenCode["ApiTokenExpired"] = 3] = "ApiTokenExpired";
  ExpiredTokenCode[ExpiredTokenCode["DuplicateLogin"] = 10] = "DuplicateLogin";
  ExpiredTokenCode[ExpiredTokenCode["Logout"] = 11] = "Logout";
})(ExpiredTokenCode || (ExpiredTokenCode = {}));